// extracted by mini-css-extract-plugin
export default {"main":"Project_main__OOxMF","title":"Project_title__DqKbo","projectContainer":"Project_projectContainer__f1yku"};